import React, { useState } from 'react';
import PageHeader from '../components/PageHeader';
import { submitEmployerComplaint } from '../services/api';

export default function EmployerComplaint() {
  const [form, setForm] = useState({
    complainantName: '', complainantPhone: '', complainantEmail: '',
    employerName: '', problemDescription: '',
  });
  const [status, setStatus] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setStatus(null);
    try {
      await submitEmployerComplaint(form);
      setStatus('success');
      setForm({ complainantName: '', complainantPhone: '', complainantEmail: '', employerName: '', problemDescription: '' });
    } catch (err) {
      setStatus('error');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <PageHeader
        eyebrow="Report a Workplace Issue"
        title="Submit a Complaint"
        subtitle="Tell us what happened. A paralegal will review your submission and follow up with you."
      />
      <section className="section">
        <div className="container" style={{ maxWidth: 640 }}>
          <div className="card">
            {status === 'success' && <div className="success-box">Thank you — your complaint has been submitted. We'll be in touch soon.</div>}
            {status === 'error' && <p className="error-text">Something went wrong. Please try again.</p>}

            <form onSubmit={handleSubmit}>
              <div className="form-row">
                <div className="form-group">
                  <label>Your Full Name</label>
                  <input name="complainantName" required value={form.complainantName} onChange={handleChange} />
                </div>
                <div className="form-group">
                  <label>Phone Number</label>
                  <input name="complainantPhone" required value={form.complainantPhone} onChange={handleChange} />
                </div>
              </div>
              <div className="form-group">
                <label>Email</label>
                <input type="email" name="complainantEmail" value={form.complainantEmail} onChange={handleChange} />
              </div>
              <div className="form-group">
                <label>Employer Name</label>
                <input name="employerName" required value={form.employerName} onChange={handleChange} />
              </div>
              <div className="form-group">
                <label>Describe the Problem</label>
                <textarea name="problemDescription" rows="5" required value={form.problemDescription} onChange={handleChange} />
              </div>
              <p style={{ fontSize: '0.85rem', color: 'var(--color-grey)' }}>
                Document and evidence uploads will be available once you register as a member,
                so we can securely link them to your case file.
              </p>
              <button type="submit" className="btn btn-gold btn-block" disabled={loading}>
                {loading ? 'Submitting...' : 'Submit Complaint'}
              </button>
            </form>
          </div>
        </div>
      </section>
    </div>
  );
}
